import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ChannelPartner} from "../../../model/channel-partner.model";
import {ChannelPartnerService} from "../../../service/channel-partner.service";

@Injectable()
export class ChannelPartnerResolver implements Resolve<ChannelPartner> {
    constructor(private channelPartnerService: ChannelPartnerService) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ChannelPartner> {
        return await this.channelPartnerService.getPartnerDetails(route.queryParams['channel-partner-id']);
    }
}
